import React from "react";
import {buildStyles} from "connectui/component/buildStyles";
import {useTheme} from "connectui/theme/ThemeProvider";
import FlexContainer from "connectui/component/layout/FlexContainer";
import Text from "connectui/component/display/Text";
import {useTranslation} from "react-i18next";

const useStyles = (theme) =>
  buildStyles({
    note: {
      padding: theme.spacing(2.5, 3.5),
      backgroundColor: theme.colors.warning200,
      borderRadius: theme.spacing(2, 0, 2, 2),
    },
  });

const MessageNote = ({message, ...props}) => {
  const {theme} = useTheme();
  const classes = useStyles(theme);
  const {t} = useTranslation();
  const isDeleted = message.message === `--deleted-note_${message.sent}--`;

  return (
    <FlexContainer className={classes.note} sx={{opacity: isDeleted ? 0.5 : 1}}>
      <Text
        variant="textSM"
        color={"warning900"}
        sx={{whiteSpace: "break-spaces"}}
      >
        {isDeleted
          ? t("inbox.conversations.notes.note-deleted")
          : message.message}
      </Text>
    </FlexContainer>
  );
};

export default MessageNote;
